import { BaseViewStore } from 'core/stores';
import { action } from 'mobx';
import PalletStore from './PalletStore';
import FulfillmentOrderStore from './FulfillmentOrderStore';
import { ShipmentInfoStore } from 'modules/shipment-info/stores';
import { fulfillmentOrderStatus, lookupRouteName, sourceOfChange } from 'common/constants';
import { ConfirmModalParams } from 'core/models';
import { notificationError } from 'core/utils';
import { LookupStore } from 'modules/lookup/stores';
import _ from 'lodash';

class ExitScanmodeDetailViewStore extends BaseViewStore {
	noDataItem = true;
	confirmDisable = true;
	pallet = null;
	palletizedLookupId = null;
	selectedItem = null;
	data = [];

	constructor(rootStore) {
		super(rootStore);
		this.authStore = rootStore.authStore;
		this.store = new PalletStore(rootStore);
		this.shipmentInfoStore = new ShipmentInfoStore(rootStore);
		this.lookupStore = new LookupStore(rootStore);
		this.fulfillmentOrderStore = new FulfillmentOrderStore(rootStore);
		this.rootStore.viewStore.modes = [];
		this.tableData = {
			columns: [
				{
					key: 'fulfillmentOrder.fulfillmentOrderId',
					title: 'EXITSCANDETAILVIEW.TABLE.FULFILLMENTORDERID',
					selected: true,
					width: 200,
					filter: null,
				},
				{
					key: 'fulfillmentOrder.fulfillmentOrderStatus.name',
					title: 'EXITSCANDETAILVIEW.TABLE.FULFILLMENTORDERSTATUS',
					selected: true,
					width: 200,
					filter: null,
				},
				{
					key: 'fulfillmentOrder.onHoldReason.name',
					title: 'EXITSCANDETAILVIEW.TABLE.ONHOLDREASON',
					selected: true,
					width: 200,
					filter: null,
				},
			],
			actions: {
				onRemoveFromPallet: async item => this.openConfirmationModal(this.getRemoveFromPalletConfirmModalProps(item)),
				onChangeStatus: async item => this.openConfirmationModal(this.getChangeStatusConfirmModalProps(item)),
			},
			sortObject: [],
		};
		this.permissions = {
			onRemoveFromPallet: () => this.authStore.hasPermission('fulfillmentOrderSection.full'),
			onChangeStatus: () => this.authStore.hasPermission('fulfillmentOrderSection.full'),
		};
		this.initalize();
	}

	@action.bound async initalize() {
		this.suspend();
		await this.getPallet(this.rootStore.routerStore.routerState.params.id, {
			embed: [
				'carrierTypeServiceType',
				'shipmentInfos',
				'shipmentInfos.fulfillmentOrder',
				'shipmentInfos.fulfillmentOrder.onHoldReason',
				'shipmentInfos.fulfillmentOrder.fulfillmentOrderStatus',
			],
		});
		await this.getLookups();
		this.checkConfirmButton();
		this.resume();
	}

	@action.bound async getLookups() {
		await this.lookupStore.find({ page: 1, rpp: 50 }, lookupRouteName.fulfillmentOrderStatus);
		this.palletizedLookupId = _.find(this.lookupStore.data, item => {
			return item.abrv == fulfillmentOrderStatus.palletized;
		}).id;
	}

	@action.bound checkConfirmButton() {
		let item = _.find(this.pallet.shipmentInfos, item => {
			return item.fulfillmentOrder.fulfillmentOrderStatus.abrv != fulfillmentOrderStatus.palletized;
		});
		if (item || this.data.length == 0) {
			this.confirmDisable = true;
		} else {
			this.confirmDisable = false;
		}
	}

	@action.bound async getPallet(id, options) {
		await this.store.getPallet(id, options);
		this.pallet = this.store.item;
		this.data = this.pallet.shipmentInfos;
	}

	@action.bound async removeFromPallet(selectedItem) {
		try {
			let item = _.cloneDeep(selectedItem);
			item.fulfillmentOrder = null;
			item.palletId = null;
			await this.shipmentInfoStore.updateShipmentInfo(item, true, sourceOfChange.exitScanModeRemoveFromPallet);
			this.rootStore.notificationStore.success([
				'EXITSCANDETAILVIEW.TABLE.ACTION.NOTIFICATION.REMOVEFROMPALLET',
				{ name: selectedItem.fulfillmentOrder.fulfillmentOrderId },
			]);
			this.initalize();
		} catch (err) {
			notificationError({ store: this.rootStore.notificationStore, err });
		}
	}

	@action.bound async changeStatus(selectedItem) {
		try {
			let fulfillmentOrder = selectedItem.fulfillmentOrder;
			fulfillmentOrder.fulfillmentOrderStatusId = this.palletizedLookupId;
			await this.fulfillmentOrderStore.updateFulfillmentOrder(fulfillmentOrder, sourceOfChange.updateOrder);
			this.rootStore.notificationStore.success([
				'EXITSCANDETAILVIEW.TABLE.ACTION.NOTIFICATION.CHANGESTATUS',
				{ name: selectedItem.fulfillmentOrder.fulfillmentOrderId },
			]);
			this.initalize();
		} catch (err) {
			notificationError({ store: this.rootStore.notificationStore, err });
		}
	}

	@action.bound async onConfirm() {
		try {
			await this.store.exitScan({ id: this.pallet.id }, sourceOfChange.exitScanModeDetail);
			this.rootStore.notificationStore.success(['EXITSCANDETAILVIEW.EXITSCANSUCCESS']);
			this.rootStore.routerStore.goBack();
		} catch (err) {
			notificationError({ store: this.rootStore.notificationStore, err });
		}
	}

	getChangeStatusConfirmModalProps = item => {
		return {
			onConfirm: async () => await this.changeStatus(this.rootStore.viewStore.selectedConfirmModal.data),
			message: ['EXITSCANDETAILVIEW.MODAL.CHANGESTATUS', { name: item.fulfillmentOrder.fulfillmentOrderId }],
			data: item,
		};
	};

	getRemoveFromPalletConfirmModalProps = item => {
		return {
			onConfirm: async () => await this.removeFromPallet(this.rootStore.viewStore.selectedConfirmModal.data),
			message: ['EXITSCANDETAILVIEW.MODAL.REMOVEFROMPALLET', { name: item.fulfillmentOrder.fulfillmentOrderId }],
			data: item,
		};
	};
}

export default ExitScanmodeDetailViewStore;
